












import { Vue, Component, Mixins } from "vue-property-decorator";

import MyCommon from "@/mixins/common";

import Stadium from "./charts/overview/stadium.vue";

@Component({
  components: {
    Stadium,
  },
})
export default class extends Mixins(MyCommon) {}
